/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper, { Navigation, Pagination, Mousewheel, EffectFade  } from "swiper";
import customEventsNames from './../customEventsNames';

Swiper.use([Navigation, Pagination]);
export function slider() {

    const projectsCardsSliderSelector = ".slider-items.swiper";
    const faoSliderSelector = ".fao-slider__slider.swiper";
    const timelineSliderSelector = ".timeline__slider.swiper";
    const menuSliderSelector = ".menu-slider__slider.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.update();

        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const init = function () {

        //Projects sliders
        const projectsSliders = [];
        const projectsSliderElements = document.querySelectorAll(projectsCardsSliderSelector);
        if (projectsSliderElements) {
            projectsSliderElements.forEach(slider => {

                projectsSliders.push(new Swiper(slider, {
                    spaceBetween: 20,
                    slidesPerView: "auto",
                    initialSlide: 0,
                    roundLengths: true,
                    centeredSlides: true,
                    longSwipes: true,
                    loop: true,

                    navigation: {
                        nextEl: ".slider-next",
                        prevEl: ".slider-prev",
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        type: 'fraction',
                        clickable: true
                    },
                    on: {
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    },
                    breakpoints: {
                        1800: {
                            spaceBetween: 35,
                            slidesPerView: 5,
                        },
                        1500: {
                            spaceBetween: 35,
                            slidesPerView: 4,
                        },
                        1400: {
                            spaceBetween: 35,
                            slidesPerView: 4,
                        },
                        1200: {
                          spaceBetween: 35,
                          slidesPerView: 3,
                        },
                        768: {
                            spaceBetween: 60,
                            slidesPerView: 2,
                        },
                      }
                }));
            })
        }

        //FAO sliders
        const faoSliders = [];
        const faoSliderElements = document.querySelectorAll(faoSliderSelector);
        if (faoSliderElements) {
            faoSliderElements.forEach((slider, index ) => {
                const sliderComponentId = slider.dataset.componentId;
                
                faoSliders.push(new Swiper(slider, {
                    spaceBetween: 15,
                    slidesPerView: "auto",
                    centeredSlides: true,
                    loop: true,
                    longSwipes: false,
                    longSwipesRatio: 0.1,
                    observer: true,
                    observeParents: true,
                    speed:400,
                    breakpoints: {
                        992: {
                            spaceBetween: 30
                        }
                    },
                    pagination: {
                        el: "#" + sliderComponentId + " .fao-slider__pagination",
                        type: 'fraction'
                    },
                    navigation: {
                        nextEl: "#" + sliderComponentId + " .fao-slider__navigation-wrap .fao-slider__navigation-next",
                        prevEl: "#" + sliderComponentId + " .fao-slider__navigation-wrap .fao-slider__navigation-prev",
                    },
                    on: {
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        },
                        resize:(swiper) =>  {
                            setTimeout(() => {
                                swiper.update();
                            },400);
                        }
                    }
                }));
            });

            const expandButtons = document.querySelectorAll('.fao-slide__expand-btn');
            if (expandButtons) {
                expandButtons.forEach(button => {
                    button.addEventListener('click', e => {
                        if (button.closest('.fao-slide').classList.contains('swiper-slide-active')) {
                            button.closest('.fao-slide').classList.add('fao-slide--expanded');
                            const sliderId = button.closest('.fao-slider__slider').id;
                            const indexOfSlider = faoSliders.findIndex(x => x.el.id == sliderId);
                            faoSliders[indexOfSlider].disable();
                            faoSliders[indexOfSlider].update();
                        }
                    });
                });
            }

            const collapseButtons = document.querySelectorAll('.fao-slide__collapse-btn');
            if (collapseButtons) {
                collapseButtons.forEach(button => {
                    button.addEventListener('click', e => {
                        const slide = button.closest('.fao-slide');
                        if (slide.classList.contains('swiper-slide-active')) {

                            slide.classList.remove('fao-slide--expanded');
                            // button.closest('.fao-slide').style.height = null;
                            const collapseTextButton = slide.querySelector('.collapsed-text__button-close');
                            if (collapseTextButton) {
                                collapseTextButton.dispatchEvent(new Event('click'));
                            }

                            const sliderId = button.closest('.fao-slider__slider').id;
                            const indexOfSlider = faoSliders.findIndex(x => x.el.id == sliderId);
                            setTimeout(() => {
                                faoSliders[indexOfSlider].update();

                            }, 400);
                            
                            faoSliders[indexOfSlider].enable();
                        }
                    });
                });
            }
        }

        const slides = document.querySelectorAll('.swiper-slide');
        if (slides) {
            slides.forEach(slide => {
                slide.addEventListener(customEventsNames.expandedCollapsedText, e => {
                    console.log(e.detail.height);
                    const slideHeight = slide.scrollHeight;
                    slide.style.height = (slideHeight + e.detail.height) + "px";
                    slide.classList.add('swiper-slide--expanded');
                });

                slide.addEventListener(customEventsNames.collapsedCollapsedText, e => {
                    slide.style.height = null;
                    slide.classList.remove('swiper-slide--expanded');
                });
            })
        }

        //Timeline sliders
        const timelineSlider = [];
        const timelineSliderSelectorElements = document.querySelectorAll(timelineSliderSelector);
        if (timelineSliderSelectorElements) {
            timelineSliderSelectorElements.forEach(slider => {

                timelineSlider.push(new Swiper(slider, {
                    modules: [Mousewheel, EffectFade],
                    slidesPerView: 1,
                    speed: 1500,
                    autoHeight: true,
                    mousewheel: true,
                    parallax: true,
                    effect: 'fade',
                    fadeEffect: {
                      crossFade: true
                    },
                   
                    pagination: {
                        type: "progressbar",
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                   
                    on: {
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    },
                }));
            })
        }

        //Menu sliders
        const menuSliders = [];
        const menuSliderElements = document.querySelectorAll(menuSliderSelector);
        if (menuSliderElements) {
            menuSliderElements.forEach(slider => {
                const indexOfCurrent = [...slider.querySelectorAll('.swiper-slide')].findIndex(x=>x.classList.contains('menu-slider__item--current'));
                const sliderComponentId = slider.dataset.componentId;

                menuSliders.push(new Swiper(slider, {
                    spaceBetween: 25,
                    slidesPerView: "auto",
                    initialSlide: indexOfCurrent,
                    loop: true,
                    navigation: {
                        nextEl: "#" + sliderComponentId + "  .menu-slider__navigation-next",
                        prevEl: "#" + sliderComponentId + "  .menu-slider__navigation-prev",
                    },
                }));
            })
        }
    };

    init();
}
